import React from 'react';
import { Select } from 'antd';
import { PAYMENT, RECEIPT } from 'constants/types';
import display from 'constants/display';

const { Option } = Select;

const SelectEntryType = (props) => {
  return (
    <Select {...props}>
      <Option value={RECEIPT}>{display[RECEIPT]}</Option>
      <Option value={PAYMENT}>{display[PAYMENT]}</Option>
    </Select>
  );
};

export default SelectEntryType;
